// BEGIN seibertronHpirgReceiverCacheFix20260714
;(function seibertronHpirgReceiverCacheFix20260714() {
  var handle = "seibertron-h-p-i-r-g-touchscreen-white-football-receiver-gloves";
  var entries = [
  {
    "id": "33443621011646",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-black-gold-palm-white-bg-20260714.jpg?v=1784017643",
    "alt": "seibertron-gallery:hpirg-black-white-bg-20260714 | product:8307911884990 | color:Black | slot:1 | Seibertron H.P.I.R.G touchscreen football receiver gloves black gold palm white background main image"
  },
  {
    "id": "33443157901502",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-01.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:2 | Seibertron H.P.I.R.G touchscreen football receiver gloves black touchscreen feature image"
  },
  {
    "id": "33443157934270",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-02.jpg?v=1784011502",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:3 | Seibertron H.P.I.R.G touchscreen football receiver gloves black field lifestyle image"
  },
  {
    "id": "33443157967038",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-04.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:4 | Seibertron H.P.I.R.G touchscreen football receiver gloves black running lifestyle image"
  },
  {
    "id": "33443157999806",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-05.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:5 | Seibertron H.P.I.R.G touchscreen football receiver gloves black catch lifestyle image"
  },
  {
    "id": "33443158032574",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-06.jpg?v=1784011502",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:6 | Seibertron H.P.I.R.G touchscreen football receiver gloves black catch lifestyle image 2"
  },
  {
    "id": "33443158065342",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-07.jpg?v=1784011502",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:7 | Seibertron H.P.I.R.G touchscreen football receiver gloves black touchdown lifestyle image"
  },
  {
    "id": "33443158098110",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-main.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:8 | Seibertron H.P.I.R.G touchscreen football receiver gloves white background main image"
  },
  {
    "id": "33443158130878",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-01.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:9 | Seibertron H.P.I.R.G touchscreen football receiver gloves white touchscreen feature image"
  },
  {
    "id": "33443158163646",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-02.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:10 | Seibertron H.P.I.R.G touchscreen football receiver gloves white football closeup image"
  },
  {
    "id": "33443158196414",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-03.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:11 | Seibertron H.P.I.R.G touchscreen football receiver gloves white palm protection image"
  },
  {
    "id": "33443158229182",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-04.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:12 | Seibertron H.P.I.R.G touchscreen football receiver gloves white glove field image"
  },
  {
    "id": "33443158261950",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-05.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:13 | Seibertron H.P.I.R.G touchscreen football receiver gloves white football closeup image 2"
  },
  {
    "id": "33443158294718",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-01.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:14 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus touchscreen feature banner"
  },
  {
    "id": "33443158327486",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-02.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:15 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus fit feature banner"
  },
  {
    "id": "33443158360254",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-03.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:16 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus breathable feature banner"
  },
  {
    "id": "33443158393022",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-04.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:17 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus protection feature banner"
  },
  {
    "id": "33443158425790",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-05.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:18 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus sticky palm feature banner"
  },
  {
    "id": "33443158458558",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-06.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:19 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus easy on feature banner"
  }
];
  var groups = {
  "Black": [
    "33443621011646",
    "33443157901502",
    "33443157934270",
    "33443157967038",
    "33443157999806",
    "33443158032574",
    "33443158065342",
    "33443158294718",
    "33443158327486",
    "33443158360254",
    "33443158393022",
    "33443158425790",
    "33443158458558"
  ],
  "White": [
    "33443158098110",
    "33443158130878",
    "33443158163646",
    "33443158196414",
    "33443158229182",
    "33443158261950",
    "33443158294718",
    "33443158327486",
    "33443158360254",
    "33443158393022",
    "33443158425790",
    "33443158458558"
  ]
};

  function currentColor(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked');
    return checked ? checked.value : '';
  }

  function isTargetRoot(root) {
    if (!root) return false;
    if (String(root.getAttribute('data-product-handle') || '') !== handle) return false;
    return String(window.location.pathname || '').indexOf(handle) !== -1;
  }

  function entryById(id) {
    id = String(id || '');
    for (var i = 0; i < entries.length; i += 1) {
      if (String(entries[i].id) === id) return entries[i];
    }
    return null;
  }

  function applyMain(root, entry) {
    if (!entry) return;
    var main = root.querySelector('[data-auto-main-image]');
    if (main && entry.src) {
      main.src = entry.src;
      main.srcset = '';
      main.alt = entry.alt || '';
      main.setAttribute('data-media-id', entry.id);
    }
    var activeThumb = root.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb === activeThumb);
      thumb.setAttribute('aria-current', thumb === activeThumb ? 'true' : 'false');
    });
  }

  function trimUnavailableColors(root) {
    root.querySelectorAll('input[name="options[Color]"], input[name="options[color]"]').forEach(function (input) {
      var keep = !!groups[input.value];
      var label = input.closest ? input.closest('label') : root.querySelector('label[for="' + input.id + '"]');
      input.disabled = !keep;
      if (label) {
        label.hidden = !keep;
        label.style.display = keep ? '' : 'none';
      }
    });
    if (!groups[currentColor(root)]) {
      var firstColor = Object.keys(groups)[0];
      var firstInput = root.querySelector('input[name="options[Color]"][value="' + firstColor + '"], input[name="options[color]"][value="' + firstColor + '"]');
      if (firstInput) {
        firstInput.checked = true;
        firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function showGroup(root, color) {
    var ids = groups[color] || groups[String(color || '').trim()] || groups.Black || [];
    var visible = {};
    ids.forEach(function (id) { visible[String(id)] = true; });
    var first = null;
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var id = String(thumb.dataset.mediaId || thumb.getAttribute('data-media-id') || '');
      var keep = !!visible[id];
      thumb.hidden = !keep;
      thumb.style.display = keep ? '' : 'none';
      if (keep && !first) first = entryById(id) || { id: id, src: thumb.dataset.src, alt: thumb.dataset.alt };
    });
    applyMain(root, first);
  }

  function hydrateSwatches(root) {
    trimUnavailableColors(root);
    Object.keys(groups).forEach(function (color) {
      var first = entryById(groups[color][0]);
      if (!first || !first.src) return;
      root.querySelectorAll('[data-auto-visual-option-value="' + color + '"], [data-auto-color-value="' + color + '"]').forEach(function (label) {
        var shell = label.querySelector('[data-auto-choice-label]');
        if (!shell) return;
        shell.dataset.display = color;
        shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + color + '"><img src="' + first.src + '" alt="' + color + '" width="72" height="72" loading="lazy"></span><span class="auto-product__swatch-label">' + color + '</span>';
      });
      root.querySelectorAll('input[name="options[Color]"][value="' + color + '"], input[name="options[color]"][value="' + color + '"]').forEach(function (input) {
        var label = input.closest ? input.closest('label') : root.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        label.style.backgroundImage = 'url("' + first.src + '")';
        label.style.backgroundSize = 'cover';
        label.style.backgroundPosition = 'center';
      });
    });
  }

  function run() {
    document.querySelectorAll('.auto-product[data-auto-product][data-product-handle="' + handle + '"]').forEach(function (root) {
      if (!isTargetRoot(root)) return;
      hydrateSwatches(root);
      showGroup(root, currentColor(root));
      if (!root.dataset.hpirgHpSeriesBound) {
        root.dataset.hpirgHpSeriesBound = 'true';
        root.addEventListener('change', function (event) {
          if (event.target && event.target.matches('input[name^="options["]')) {
            window.setTimeout(function () { hydrateSwatches(root); showGroup(root, currentColor(root)); }, 0);
          }
        });
        root.addEventListener('click', function (event) {
          var thumb = event.target && event.target.closest ? event.target.closest('[data-auto-thumb]') : null;
          if (!thumb || thumb.hidden || thumb.style.display === 'none') return;
          var entry = entryById(thumb.dataset.mediaId) || { id: thumb.dataset.mediaId, src: thumb.dataset.src, alt: thumb.dataset.alt };
          applyMain(root, entry);
        }, true);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  window.setTimeout(run, 250);
  window.setTimeout(run, 1200);
  window.setTimeout(run, 3000);
})();
// END seibertronHpirgReceiverCacheFix20260714
/* hpirg-standalone-cache-refresh: 2026071423 */
